import React from "react";
import styles from "./AdPerformance.module.scss";
import { Container } from "reactstrap";
import Overview from "./Overview/Overview";
import PerformanceOverTime from "./PerformanceOverTime/PerformanceOverTime";
import DistributionChart from "./DistributionChart/DistributionChart";
import Performance from "./Performance/Performance";

const AdPerformance = () => {
  return (
    <div className={styles.mainContainer}>
      <Container fluid className="p-0">
        <h4 className="fw-semibold mb-3">Ad Performance</h4>
        <div>
          <Overview />
          <PerformanceOverTime />
          <DistributionChart />
          <Performance />
        </div>
      </Container>
    </div>
  );
};

export default AdPerformance;